export enum EmailContextEnum {
  STATISTIQUE_EGALIM
}
